module.exports = __webpack_public_path__ + "static/media/cristian_romero.842ec7f7.jpg";